export let EditorHost = /*#__PURE__*/function (EditorHost) {
  EditorHost["editor"] = "classic-editor";
  EditorHost["studio"] = "studio";
  EditorHost["odeditor"] = "odeditor";
  return EditorHost;
}({});
export let RuleListStatus = /*#__PURE__*/function (RuleListStatus) {
  RuleListStatus["failed"] = "failed";
  RuleListStatus["passed"] = "passed";
  RuleListStatus["error"] = "error";
  RuleListStatus["disabled"] = "disabled";
  RuleListStatus["recommendation"] = "recommendation";
  RuleListStatus["loading"] = "loading";
  RuleListStatus["pending"] = "pending";
  return RuleListStatus;
}({});
export let GroupType = /*#__PURE__*/function (GroupType) {
  GroupType["StaticPage"] = "static-page";
  GroupType["ProductPage"] = "product-page";
  GroupType["ServicePage"] = "service-page";
  GroupType["SiteLevel"] = "site-level";
  GroupType["BlogPosts"] = "blog-posts";
  GroupType["EventPage"] = "event-page";
  GroupType["PortfolioProjects"] = "portfolio-projects";
  GroupType["OnlinePrograms"] = "online-programs";
  GroupType["GroupsPage"] = "groups-page";
  GroupType["RestaurantsMenu"] = "restaurants-menu";
  return GroupType;
}({});
export let ToggleType = /*#__PURE__*/function (ToggleType) {
  ToggleType["Expand"] = "expand";
  ToggleType["Collapse"] = "collapse";
  return ToggleType;
}({});
/** predefined Fixer components **/
export let FixerType = /*#__PURE__*/function (FixerType) {
  FixerType["InputRule"] = "InputRule";
  FixerType["EvergreenRule"] = "EvergreenRule";
  FixerType["DropdownRule"] = "DropdownRule";
  FixerType["RadioGroupRule"] = "RadioGroupRule";
  FixerType["Custom"] = "Custom";
  FixerType["ToggleRule"] = "ToggleRule";
  return FixerType;
}({});
export let GroupExpansionStyle = /*#__PURE__*/function (GroupExpansionStyle) {
  GroupExpansionStyle["collapsible"] = "collapsible";
  GroupExpansionStyle["button"] = "button";
  return GroupExpansionStyle;
}({});
//# sourceMappingURL=types.js.map